import React from "react";
import { cardData } from "./DataUtils";

export const DateFormatter = (dateString: string) => {
  // Given date in format 'YYYY-MM-DD'
  const [day, month, year] = dateString?.split(".");

  // Create a new Date object using "YYYY-MM-DD" format, which is recognized by JavaScript
  const formattedDate = new Date(`${year}-${month}-${day}`);

  // Check for Invalid Date
  if (isNaN(formattedDate.getTime())) {
    console.error("Invalid date:", dateString);
    return "Invalid date"; // or return a fallback value
  }

  // Format the date to 'Wednesday, 21 January 2025'
  return new Intl.DateTimeFormat("en-GB", {
    weekday: "long", // Full weekday name (e.g., "Wednesday")
    day: "2-digit", // Day of the month, 2 digits (e.g., "21")
    month: "long", // Full month name (e.g., "January")
    year: "numeric", // 4-digit year (e.g., "2025")
  }).format(formattedDate);
};

export const formatDateEmail = (dateString: string) => {
  if (dateString === null || dateString === undefined) return;

  const monthsInGerman = [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ];

  const [day, month, year] = dateString?.split(".");

  const monthInGerman = monthsInGerman[parseInt(month) - 1];

  return `Start ${day}. ${monthInGerman} ${year}`;
};

export function getDayInGerman(dateString: string) {
  if (dateString === null || dateString === undefined) return;
  const daysInGerman = [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ];

  const shortenDaysInGerman = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

  const [day, month, year] = dateString?.split(".");

  const date = new Date(`${year}-${month}-${day}`);

  const dayOfWeek = date?.getDay();

  return shortenDaysInGerman[dayOfWeek];
}

export function filterFutureDates(data: cardData[]) {
  // Helper function to parse the date string into a Date object
  const parseDate = (dateStr: string): Date => {
    const [day, month, year] = dateStr.split(".");
    return new Date(`${year}-${month}-${day}`);
  };

  // Get today's date (with time set to 00:00:00) for comparison
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Set to midnight

  // Filter out objects where fDate is in the future or today
  return data.filter((item) => parseDate(item.fDate) >= today);
}

export const weekOrder: Record<string, number> = {
  Monday: 0,
  Tuesday: 1,
  Wednesday: 2,
  Thursday: 3,
  Friday: 4,
  Saturday: 5,
  Sunday: 6,
};
